import { render, staticRenderFns } from "./BiddingTimeStatus.vue?vue&type=template&id=5880339d&scoped=true"
import script from "./BiddingTimeStatus.vue?vue&type=script&lang=js"
export * from "./BiddingTimeStatus.vue?vue&type=script&lang=js"
import style0 from "./BiddingTimeStatus.vue?vue&type=style&index=0&id=5880339d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880339d",
  null
  
)

export default component.exports